import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { Store } from '@ngxs/store';
import { ApplicationSelectors } from '@frontend/unhideschool/app/shared-nxgs/application/application.selectors';
import { LoggedUserStateService } from '@frontend/unhideschool/core/services/legacy/logged-user.state';

@Component({
  selector: 'unh-slider-videos',
  templateUrl: './slider-videos.component.html',
  styleUrls: ['./slider-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class SliderVideosComponent implements OnInit {
  @Input() slides = [];
  @Input() free = false;

  slidesLoading = [{}, {}, {}, {}, {}, {}, {}, {}, {}];

  config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 6,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    loop: false,
    slidesOffsetBefore: 80,
    slidesOffsetAfter: 80,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      480: {
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

      },
      570: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      650: {
        slidesPerView: 1.5,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      750: {
        slidesPerView: 1.7,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },

      768: {
        slidesPerView: 1.9,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
        spaceBetween: 20,
      },
      850: {
        slidesPerView: 2.1,
      },
      950: {
        slidesPerView: 2.2,
      },
      1050: {
        slidesPerView: 2.4,
      },
      1100: {
        slidesPerView: 2.6,
      },
      1150: {
        slidesPerView: 3.0,

      },
      1250: {
        slidesPerView: 3.1,
      },
      1350: {
        slidesPerView: 3.3,

      },
      1450: {
        slidesPerView: 3.4,

      },
      1550: {
        slidesPerView: 3.6,
      },
      1650: {
        slidesPerView: 4.2,
      },
      1750: {
        slidesPerView: 4.5,
      },
      1850: {
        slidesPerView: 4.7,

      },

      1950: {
        slidesPerView: 4.9,

      },

      2050: {
        slidesPerView: 5.2,
      },
      2250: {
        slidesPerView: 5.5,
      },
      2550: {
        slidesPerView: 6,
      },
      2650: {
        slidesPerView: 6.5,
      },
      2750: {
        slidesPerView: 7,
      },
      3050: {
        slidesPerView: 7.3,
      },
    }
  };

  configClosed: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 6,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    loop: false,
    slidesOffsetBefore: 80,
    slidesOffsetAfter: 80,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      480: {
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

      },
      570: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      650: {
        slidesPerView: 1.5,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      750: {
        slidesPerView: 1.7,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },

      768: {
        slidesPerView: 1.9,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
        spaceBetween: 20,
      },
      850: {
        slidesPerView: 2.1,
      },
      950: {
        slidesPerView: 2.2,
      },
      1050: {
        slidesPerView: 2.4,
      },
      1100: {
        slidesPerView: 2.6,
      },
      1150: {
        slidesPerView: 3.0,

      },
      1250: {
        slidesPerView: 3.1,
      },
      1350: {
        slidesPerView: 3.4,

      },
      1450: {
        slidesPerView: 3.4,

      },
      1550: {
        slidesPerView: 3.6,
      },
      1650: {
        slidesPerView: 4,
      },
      1750: {
        slidesPerView: 4,
      },
      1850: {
        slidesPerView: 4.5,

      },

      1950: {
        slidesPerView: 4.7,

      },

      2050: {
        slidesPerView: 5,
      },
      2250: {
        slidesPerView: 5.2
      },
      2550: {
        slidesPerView: 5.7,
      },
      2650: {
        slidesPerView: 6.2,
      },
      2750: {
        slidesPerView: 6.5,
      },
      3050: {
        slidesPerView: 7.1,
      },
    }
  };
  configOpen: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 6,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    loop: false,
    slidesOffsetBefore: 80,
    slidesOffsetAfter: 80,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      480: {
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

      },
      570: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      650: {
        slidesPerView: 1.5,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
      750: {
        slidesPerView: 1.7,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },

      768: {
        slidesPerView: 1.9,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
        spaceBetween: 20,
      },
      850: {
        slidesPerView: 2.1,
      },
      950: {
        slidesPerView: 2.2,
      },
      1050: {
        slidesPerView: 2.4,
      },
      1100: {
        slidesPerView: 2.6,
      },
      1150: {
        slidesPerView: 3.0,

      },
      1250: {
        slidesPerView: 2.5,
      },
      1350: {
        slidesPerView: 2.8,

      },
      1450: {
        slidesPerView: 2.8,

      },
      1550: {
        slidesPerView: 3,
      },
      1650: {
        slidesPerView: 3,
      },
      1750: {
        slidesPerView: 3.6,
      },
      1850: {
        slidesPerView: 4,

      },

      1950: {
        slidesPerView: 4.3,

      },

      2050: {
        slidesPerView: 4.5,
      },
      2250: {
        slidesPerView: 4.8,
      },
      2550: {
        slidesPerView: 5.3,
      },
      2650: {
        slidesPerView: 5.8,
      },
      2750: {
        slidesPerView: 6.3,
      },
      3050: {
        slidesPerView: 6.7,
      },
    }
  };

  configloading: SwiperConfigInterface = {
    ...this.config,
    navigation: false
  }

  constructor(
    private store: Store,
    private cdr: ChangeDetectorRef,
    private luss: LoggedUserStateService
  ) {
    // this.cdr.detach();

  }
  ngOnInit() {
    this.store.select(ApplicationSelectors.observeSidebarToggleState()).subscribe(
      toggle => {
        if (toggle && this.luss.isLogged) {
          this.config = this.configOpen;
            this.cdr.detectChanges();
          } else {
          setTimeout(() => {
            this.config = this.configClosed;
            this.cdr.detectChanges();
          }, 180)
        }
      }

    )
  }
}
